import { ScalePreview } from '../ScalePreview';
import { DeviceFrame } from 'foundations-components/transitional/components/DeviceFrame';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const ToolPreview = ({
  children,
  scale = 0.5
}) => {
  return /*#__PURE__*/_jsx(DeviceFrame, {
    blockSize: "100%",
    children: /*#__PURE__*/_jsx(View, {
      overflow: "hidden",
      inlineSize: "100%",
      blockSize: "100%",
      children: /*#__PURE__*/_jsx(ScalePreview, {
        scale: scale,
        children: children
      })
    })
  });
};